import Vue from "vue";
import Vuex from "vuex";
import { IUser, Roles } from "@/models/user";
import { IFabric } from "@/models/fabric";

Vue.use(Vuex);

export interface RootState {
  isLoggedIn: boolean;
  user: IUser | null;
  role: Roles | null;
  // One-shot handoff for "Duplicate fabric": EditView stashes a partial fabric
  // here and routes to /new, which consumes it as the form's starting values.
  // Too large and too nested to pass through the query string. Consume-once —
  // AddView clears it on read, so a later visit to /new starts blank rather than
  // silently resurrecting a clone the user abandoned.
  fabricDraft: Partial<IFabric> | null;
}

export default new Vuex.Store<RootState>({
  state: {
    isLoggedIn: false,
    user: null,
    role: null,
    fabricDraft: null,
  },
  getters: {
    isLoggedIn: (state) => state.isLoggedIn,
    user: (state) => state.user,
    role: (state) => state.role,
    isAdmin: (state) => state.role === Roles.Admin,
    fabricDraft: (state) => state.fabricDraft,
  },
  mutations: {
    SET_AUTH(state, user: IUser | null) {
      state.user = user;
      state.role = user ? user.role : null;
      state.isLoggedIn = !!user;
    },
    CLEAR_AUTH(state) {
      state.user = null;
      state.role = null;
      state.isLoggedIn = false;
    },
    SET_FABRIC_DRAFT(state, draft: Partial<IFabric> | null) {
      state.fabricDraft = draft;
    },
    CLEAR_FABRIC_DRAFT(state) {
      state.fabricDraft = null;
    },
  },
  actions: {
    setAuth({ commit }, user: IUser | null) {
      commit("SET_AUTH", user);
    },
    clearAuth({ commit }) {
      commit("CLEAR_AUTH");
    },
  },
  modules: {},
});
